module.exports = __webpack_public_path__ + "media/images/article/2021_11-d1f2cce2fd5054a1f564f63525b5e5b1.png";